import { render, staticRenderFns } from "./BpProfitLossMonthlyComparisonComparison.vue?vue&type=template&id=35d29d7d"
import script from "./BpProfitLossMonthlyComparisonComparison.vue?vue&type=script&lang=ts"
export * from "./BpProfitLossMonthlyComparisonComparison.vue?vue&type=script&lang=ts"
import style0 from "./BpProfitLossMonthlyComparisonComparison.vue?vue&type=style&index=0&id=35d29d7d&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports